import type { ConnectionStatusType } from "@/types"
import { ColumnDef } from "@tanstack/react-table"

import { DataTableColumnHeader } from "../../data-table"
import { ConnectionStatusOperation } from "../operations/connection-status-operation"

export const connectionStatus: ColumnDef<ConnectionStatusType>[] = [
  {
    accessorKey: "status_name",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Name"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.status_name
      return <div className="overflow-hidden truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Description"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div className="overflow-hidden truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "sequence",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Sequence"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.sequence
      return <div className="overflow-hidden truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "icon",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Icon"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.icon
      return <div className="overflow-hidden truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <ConnectionStatusOperation data={row.original} />
        </div>
      )
    },
  },
]
